import { SWRConfig } from 'swr';
import request from '../services/api/request';

const SWRProvider = ({ children }) => {
  return (
    <SWRConfig
      value={{
        fetcher: request,
        shouldRetryOnError: (error) => {
          // Don't retry on authentication errors
          if (error?.status === 401 || error?.status === 403) {
            return false;
          }
          // Don't retry on 4xx errors (client errors)
          if (error?.status >= 400 && error?.status < 500) {
            return false;
          }
          // Retry on network errors and 5xx errors
          return true;
        },
        errorRetryCount: 3,
        errorRetryInterval: 5000,
        // Revalidate on window focus for fresh data
        revalidateOnFocus: true,
        // Revalidate when coming back online
        revalidateOnReconnect: true,
        // Don't revalidate on mount if data is fresh
        revalidateIfStale: false,
        // Cache time (5 minutes)
        dedupingInterval: 5 * 60 * 1000,
        onError: (error, key) => {
          console.error('SWR Error:', { key, error });

          // Handle authentication errors globally
          if (error?.status === 401) {
            console.warn('Authentication error detected, user may need to re-login');
            // Don't auto-redirect here as it might be handled by the interceptor
          }
        },
      }}
    >
      {children}
    </SWRConfig>
  );
};

export default SWRProvider;
